import { FETCH_ONBOARDING } from "../../actions/actionTypes";


const onBoardingReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_ONBOARDING:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

export default onBoardingReducer;